import Link, { LinkProps } from './Link'

export default Link

export { Link }
export type { LinkProps }
